import { AmexError, AmexGatewayValidationError } from '@Shared/interfaces';

export const getAmexErrorsFromAmexGatewayValidationError = (serverError: string): AmexError[] | null => {
  let parsedServerError: AmexGatewayValidationError = JSON.parse(serverError)?.data;
  if (!parsedServerError) {
    parsedServerError = JSON.parse(serverError);
  }

  if (parsedServerError.errors) {
    const errors: AmexError[] = [];
    parsedServerError?.errors.forEach((error) => {
      error?.cardUserErrors.forEach((cardError) => {
        cardError?.errors.forEach((err) => {
          errors.push(err);
        });
      });
    });

    if (errors.length) {
      return errors;
    }
  }

  return null;
};
